import { BarChart3 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MarginsTab } from "./MarginsTab";
import { BillingLinksTab } from "./BillingLinksTab";
import { BillingCheckTab, ImpactTab } from "./BillingCheckTab";

/** Staff insights: margins, billing links, billing check and batch impact. */
export function PriceInsightsDialog({ d }) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" data-testid="price-insights-open"><BarChart3 className="h-3.5 w-3.5" /> Margins & billing</Button>
      </DialogTrigger>
      <DialogContent className="max-w-5xl" data-testid="price-insights-dialog">
        <DialogHeader>
          <DialogTitle>Margins & billing</DialogTitle>
          <DialogDescription>Staff only — partners never see this.</DialogDescription>
        </DialogHeader>
        <Tabs defaultValue="margins">
          <TabsList>
            <TabsTrigger value="margins" data-testid="price-insights-tab-margins">Margins</TabsTrigger>
            <TabsTrigger value="links" data-testid="price-insights-tab-links">Billing links</TabsTrigger>
            <TabsTrigger value="check" data-testid="price-insights-tab-check">Billing check</TabsTrigger>
            <TabsTrigger value="impact" data-testid="price-insights-tab-impact">Impact per partner</TabsTrigger>
          </TabsList>
          <TabsContent value="margins"><MarginsTab /></TabsContent>
          <TabsContent value="links"><BillingLinksTab /></TabsContent>
          <TabsContent value="check"><BillingCheckTab batches={d.batches} /></TabsContent>
          <TabsContent value="impact"><ImpactTab batches={d.batches} /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
}
